import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectShipmentData = state => selectState(state).data;
export const selectShipmentLoading = state => selectState(state).loading;
export const selectShipmentLoadingMore = state => selectState(state).loadingMore;
export const selectfetchShipmentLoading = state => selectState(state).shipmentLoading;
export const selectShipmentError = state => selectState(state).error;
export const selectShipmentFilterVisible = state => selectState(state).filterVisible;
export const selectShipmentFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectShipmentPagination = state => selectState(state).pagination;
export const selectShipmentHasMore = state => Boolean(selectState(state).pagination?.hasMore);

// List filtering is server-side via getallpaged (header part/PO + toolbar ASP/trailer/PSN/customer).
export const selectFilteredShipments = createSelector([selectShipmentData], data => data ?? []);
